import {css} from '@yandex-delivery/blocks/theme/css'

export const image = css`
  animation: rideId 0.3s forwards ease-out;

  @keyframes rideIn {
    0% {
      transform: translate(-4px, 1px);
      opacity: 0;
    }
    100% {
      opacity: 100%;
      transform: translate(0, 0);
    }
  }
`
